import React from 'react';
import { Box } from '@mui/material';
import './AccountDetailsHorizontalLine.scss';

const AccountDetailsHorizontalLine: React.FunctionComponent = () => {
  return <Box className="horizontal-line-container"></Box>;
};

export default AccountDetailsHorizontalLine;
